import { IChangeDateScrollableAction } from '../../../actions/bookingCalendar/date/changeDateRange'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IChangeDateScrollableAction,
): IBookingCalendarStore {
  return {
    ...state,
    dates: {
      ...state.dates,
      scrollable: {
        from: action.startDate,
        to: action.finishDate,
      },
    },
  }
}
